import { ErrorInfo } from "@bootstrap";
import { PageContent } from "@/components/PageContent/PageContent";

/**
 * Transient state shown while a stale code-split chunk triggers a recovery
 * reload onto the current asset graph. Shared by the route error boundaries so
 * the copy and layout stay identical.
 *
 * `fullScreen` is for boundaries that render outside the authenticated shell
 * (no nav chrome) — RootErrorBoundary and AuthErrorBoundary. RouteErrorBoundary
 * renders inside the shell, so it uses the PageContent layout.
 */
export const ChunkUpdatingNotice = ({
  fullScreen = false,
}: {
  fullScreen?: boolean;
}) => {
  const notice = (
    <ErrorInfo
      title="Updating…"
      subtitle="Loading the latest version"
      description="This will only take a moment."
    />
  );

  if (fullScreen) {
    return (
      <main className="flex h-screen w-full items-center justify-center p-8">
        {notice}
      </main>
    );
  }

  return <PageContent>{notice}</PageContent>;
};
